/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Delivered_FromInputs */

const vi_order_delivered_from = /** @type {(inputs: Order_Delivered_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao từ ngày`)
};

/**

* @param {Order_Delivered_FromInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_delivered_from = /** @type {((inputs?: Order_Delivered_FromInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Delivered_FromInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_delivered_from(inputs)
});